<template>
  <div class="p-company-settings">
    <VTabsRouter :tabs="tabs" />
  </div>
</template>

<script>
import VTabsRouter from '@/components/deprecated/molecules/TabsRouter.vue';

export default {
  name: 'CompanySettings',
  components: {
    VTabsRouter,
  },
  data() {
    return {
      tabs: [
        { title: this.$t('companySettings.companyProfile.title'), route: '/company-settings/profile', icon: 'building' },
        { title: this.$t('companySettings.preferences.title'), route: '/company-settings/preferences', icon: 'cog' },
        { title: this.$t('companySettings.developer.title'), route: '/company-settings/developer', icon: 'code' },
        { title: this.$t('companySettings.security.title'), route: '/company-settings/security', icon: 'lock' },
        { title: this.$t('companySettings.billing.title'), route: '/company-settings/billing', icon: 'credit-card' },
        { title: this.$t('companySettings.integrations.title'), route: '/company-settings/integrations', icon: 'plug' },
        { title: this.$t('companySettings.data.title'), route: '/company-settings/data', icon: 'cloud-download' },
      ],
    };
  },
};
</script>
